import React, { useState } from 'react';
import { useDispatch } from 'react-redux'

import AppButton from '../../atoms/AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../../atoms/AppButton/AppButtonProps'
import { monthsAmountDisplayedNames, sleep } from '../../../common/helpers/helpers'
import { PredefinedPeriodButtonsProps } from './PredefinedPeriodButtonsProps'
import { SET_CURRENT_SELECTED_PREDEFINED_PERIOD } from '../../../store/actions/application-actions'
import { Environment } from '../../../environment/app-settings'
import { PREDEFINED_PERIODS_OFFER_LOGIC } from '../../../store/types'

import './PredefinedPeriodButtonsStyles.scss'


/**
 * [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI
 * Przyciski pozwalające na zmianę okresu pożyczki
 * @returns 
 */
const PredefinedPeriodButtons = (props: PredefinedPeriodButtonsProps) => {
   const dispatch = useDispatch()
   const SWITCH_BETWEEN_PERIODS_DEFAULT_DELAY_MS = 600
   const { currentSelectedPeriod, isLoading, setIsButtonLoading, setCurrentSelectedPeriod, handleAdditionalActionOnButtonClick } = props
   

   const handleChangeLoanPeriod = async (newSelectedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC) => {
      if(isLoading === true || currentSelectedPeriod === undefined || currentSelectedPeriod === newSelectedPeriod) { // Zapobiega spamowaniu przycisków z okresami
         return
      }
      
      setIsButtonLoading(true)
      setCurrentSelectedPeriod(newSelectedPeriod)

      dispatch({
         type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
         payload: newSelectedPeriod
      })


      if(handleAdditionalActionOnButtonClick !== undefined) {
         await handleAdditionalActionOnButtonClick(newSelectedPeriod)
      }

      await sleep(SWITCH_BETWEEN_PERIODS_DEFAULT_DELAY_MS)
      setIsButtonLoading(false)
   
   }
   

   if(currentSelectedPeriod === undefined) {
      return null
   }

   return (
      <div className='predefined-offer-page-predefined-period-buttons-wrapper'>
         <AppButton 
            onClick={() => handleChangeLoanPeriod(PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD)} 
            uiButtonType={ currentSelectedPeriod === PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD ? UI_BUTTON_TYPE.SECONDARY : UI_BUTTON_TYPE.OUTLINE } 
            className='predefined-offer-page-predefined-period-button'
         >
            { monthsAmountDisplayedNames(Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD]) }
         </AppButton>
         <AppButton 
            onClick={() => handleChangeLoanPeriod(PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD)} 
            uiButtonType={currentSelectedPeriod === PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD ? UI_BUTTON_TYPE.SECONDARY : UI_BUTTON_TYPE.OUTLINE } 
            className='predefined-offer-page-predefined-period-button'
         >
            { monthsAmountDisplayedNames(Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD]) }
         </AppButton>
      </div>
   )
}

export default PredefinedPeriodButtons